/**
 * Route visibility by channel: the `CHANNEL` bits and `isVisibleForChannel`, free of page imports, React,
 * MUI and `window` access.
 */

// Bitmask on ITSRoutes.Channel. 3 means visible in both.
export const CHANNEL = { STANDARD: 1, LONG: 2 };

/**
 * Does this route belong to the channel currently in use?
 *
 * Driven entirely by the route's `channel` bitmask from `GET Routes/UserRoutes`.
 * The test is symmetric — standard mode checks the STANDARD bit, long-channel
 * mode checks the LONG bit — so the DB is the single source of truth for both.
 *
 * A route with no `channel` is treated as visible in both rather than hidden:
 * `undefined & 1` is 0, so failing closed on a missing field would blank the
 * whole sidebar.
 *
 * @param {{ name?: string, channel?: number }} route
 * @param {boolean} isLongChannel
 * @returns {boolean}
 */
export const isVisibleForChannel = (route, isLongChannel) => {
  const { channel } = route ?? {};

  if (typeof channel !== 'number') return true;

  return Boolean(channel & (isLongChannel ? CHANNEL.LONG : CHANNEL.STANDARD));
};
